<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['analyze']);

const handleAnalyze = () => {
  emit('analyze');
};
</script>

<template>
  <div class="flex flex-col items-center justify-center flex-1 py-8 px-4">
    <div
      class="w-16 h-16 rounded-full bg-n-solid-3 flex items-center justify-center mb-4"
    >
      <span class="i-lucide-sparkles text-3xl text-n-slate-10" />
    </div>

    <h3 class="text-base font-semibold text-n-slate-12 mb-2 text-center">
      {{ $t('AGENTS_SIDECAR.EMPTY.TITLE') }}
    </h3>

    <p class="text-sm text-n-slate-10 text-center max-w-[280px] mb-6">
      {{ $t('AGENTS_SIDECAR.EMPTY.DESCRIPTION') }}
    </p>

    <Button faded slate sm @click="handleAnalyze">
      <span class="i-lucide-play mr-1.5" />
      {{ $t('AGENTS_SIDECAR.EMPTY.ANALYZE_BUTTON') }}
    </Button>

    <div class="mt-8 pt-6 border-t border-n-weak w-full">
      <p class="text-xs text-n-slate-10 text-center mb-3">
        {{ $t('AGENTS_SIDECAR.EMPTY.FEATURES_TITLE') }}
      </p>
      <ul class="space-y-2">
        <li class="flex items-center gap-2 text-xs text-n-slate-11">
          <span class="i-lucide-file-text text-n-slate-9" />
          {{ $t('AGENTS_SIDECAR.EMPTY.FEATURE_SUMMARY') }}
        </li>
        <li class="flex items-center gap-2 text-xs text-n-slate-11">
          <span class="i-lucide-message-circle text-n-slate-9" />
          {{ $t('AGENTS_SIDECAR.EMPTY.FEATURE_DRAFT') }}
        </li>
        <li class="flex items-center gap-2 text-xs text-n-slate-11">
          <span class="i-lucide-lightbulb text-n-slate-9" />
          {{ $t('AGENTS_SIDECAR.EMPTY.FEATURE_SUGGESTIONS') }}
        </li>
        <li class="flex items-center gap-2 text-xs text-n-slate-11">
          <span class="i-lucide-search text-n-slate-9" />
          {{ $t('AGENTS_SIDECAR.EMPTY.FEATURE_QUERY') }}
        </li>
      </ul>
    </div>
  </div>
</template>
